import { Typography } from '@app/components';
import { clsxm } from '@app/styles/clsxm';

// admin-dashboard-opdracht.md §6: "Gelijk aan het e-mailbeheer, uit de bestaande UI Kit." Same
// shadow/radius/padding as pages/email/shared/EmailCard.tsx.
export const DashboardCard: React.FC<{
  title?: string;
  subtitle?: React.ReactNode;
  headerRight?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}> = ({ title, subtitle, headerRight, className, children }) => (
  <div className={clsxm('rounded-md bg-white p-5 shadow-card', className)}>
    {(title || headerRight) && (
      <div className="mb-3 flex items-start justify-between gap-4">
        <div>
          {title && (
            <Typography variant="s" className="font-bold text-gray-800">
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="xxs" className="mt-0.5 text-gray-400">
              {subtitle}
            </Typography>
          )}
        </div>
        {headerRight}
      </div>
    )}
    {children}
  </div>
);
